import React from 'react'

const UserAvatar = ({size = '48px', image}) => {
  const instanceOfFile = image instanceof File

  return !instanceOfFile ? (
    <div
      style={{width: size, height: size, backgroundColor: '#ddd', backgroundImage: `url('${image}')`}}
      className="bg-no-repeat bg-center bg-cover rounded-full shadow"
    />
  ) : (
    <img src={URL.createObjectURL(image)} width={size} alt="img" />
  )
}

export { UserAvatar }
